import { Component } from '@angular/core';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor(private menuService: MenuService) {}

  showSideBarSearch() {
    this.menuService.setShowSearchMenu();
  }
}
